export enum DeviceTypeEnum {
    Device = 'TEE_BOX',
    Camera = 'HOLE_BOX',
}

export const deviceTypesFilterArray = [
    {value: 'all', label: 'All'},
    ...Object.entries(DeviceTypeEnum).map(([label, value]) => ({
        value,
        label,
    })),
];

export enum DeviceStatus {
    Online = 'ONLINE',
    Offline = 'OFFLINE',
    Sleeping = 'SLEEPING',
    Error = 'ERROR',
    Streaming = 'STREAMING',
    Waking = 'WAKING',
}

export const deviceStatusesFilterArray = [
    {value: 'all', label: 'All'},
    ...Object.entries(DeviceStatus).map(([label, value]) => ({
        value,
        label,
    })),
];


